<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-toolbar>Error</mat-toolbar>

<mat-dialog-content>

    <div class="alert-message">
        <h3>Oh no!</h3>
        <span>
            We seem to have encountered a bit of an issue.
            We'll do our best to keep going, but if we can't, give your
            support contact a call.
        </span>

    </div>
    <mat-expansion-panel>
        <mat-expansion-panel-header>Details</mat-expansion-panel-header>
        <div>{{message}}</div>
    </mat-expansion-panel>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
